<template>
  <div class="bar-graph" ref="barWrapper">
    <div class="bar-graph__wrapper">
      <div class="bar-graph__value" :style="barStyles"></div>
    </div>
    <div class="bar-graph__info">
      <div class="bar-graph__percentage">{{percentage}}%</div>
      <div class="bar-graph__description">{{description}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { vuexGetters } from "../../store";

export default {
  name: "BarGraph",
  props: {
    percentage: {
      type: Number,
      default: 1
    },
    description: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentPercentage: 5,
      maxPercentage: this.percentage,
      observer: null,
      visiblePercentage: 5,
      hasListener: false
    };
  },
  computed: {
    ...mapGetters({ visibleHeight: vuexGetters.VISIBLE_HEIGHT }),
    barStyles() {
      return {
        width: `${this.currentPercentage}%`
      };
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(this.ioCallback);
    this.observer.observe(this.$refs.barWrapper);
  },
  methods: {
    ioCallback(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasListener) {
          this.hasListener = true;
          window.addEventListener("scroll", this.setVisiblePercentage);
        } else if (!entry.isIntersecting && this.hasListener) {
          this.hasListener = false;
          window.removeEventListener("scroll", this.setVisiblePercentage);
        }
      });
    },
    fillBar() {
      if (this.$refs.barWrapper) {
        const max = this.visibleHeight.height * 0.5;
        const offsetTop =
          this.$refs.barWrapper.offsetTop - this.visibleHeight.center;
        let currentOffset = 100;
        if (offsetTop <= 0) {
          currentOffset = 0;
        } else if (offsetTop >= max) {
          currentOffset = max;
        } else {
          currentOffset = offsetTop;
        }
        return 1 - currentOffset / max;
      }
    },
    setVisiblePercentage() {
      let newPercentage = this.fillBar() * this.maxPercentage;
      if (newPercentage < this.visiblePercentage)
        newPercentage = this.visiblePercentage;
      this.currentPercentage = newPercentage;
    }
  }
};
</script>

<style lang="scss" scoped>
.bar-graph {
  &:not(:last-child) {
    margin-bottom: 30px;
  }

  &__wrapper {
    background-color: rgba($french-gray, 0.3);
    border-radius: 10px;
    display: block;
    height: 1rem;
    margin-bottom: 10px;
  }

  &__value {
    background: transparent linear-gradient(270deg, #ffca00 0%, #5a338f 100%) 0%
      0% no-repeat padding-box;
    border-radius: 10px;
    display: block;
    height: 1rem;
  }

  &__info {
    align-items: center;
    color: $eminence;
    display: flex;
    font-size: 0.8125rem;
    line-height: 1.5rem;
    justify-content: flex-start;
  }

  &__percentage {
    flex: 0 0 50px;
    font-weight: 700;
    @media screen and (min-width: 544px) {
      font-size: 0.9375rem;
      line-height: 1.5rem;
    }
  }

  &__description {
    @media screen and (min-width: 544px) {
      font-size: 0.9375rem;
      line-height: 1.5rem;
    }
  }
}
</style>